import { useEffect, useRef, useState } from "react";
import { apiFetch } from "../../api";
import { getFile, putFile } from "./cache";

async function sourceFor(url: string, fileId: string, mime: string): Promise<string> {
  try {
    const response = await apiFetch(url);
    if (!response.ok) throw new Error("missing");
    const bytes = await response.arrayBuffer();
    void putFile({ id: fileId, mime, filename: "audio", bytes: bytes.slice(0), savedAt: new Date().toISOString() }).catch(() => undefined);
    return URL.createObjectURL(new Blob([bytes], { type: mime }));
  } catch {
    const cached = await getFile(fileId);
    if (!cached) throw new Error("This audio is not on this device yet.");
    return URL.createObjectURL(new Blob([cached.bytes], { type: cached.mime || mime }));
  }
}

export function GuideAudio({ url, fileId, mime, label }: { url: string; fileId: string; mime: string; label: string }) {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [src, setSrc] = useState("");
  const [loop, setLoop] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    let objectUrl = "";
    setError("");
    void sourceFor(url, fileId, mime)
      .then((next) => {
        if (cancelled) {
          URL.revokeObjectURL(next);
          return;
        }
        objectUrl = next;
        setSrc(next);
      })
      .catch((caught: Error) => {
        if (!cancelled) setError(caught.message);
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, fileId, mime]);

  function toggle() {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) void audio.play().catch(() => setError("Playback was blocked. Press play on the audio control."));
    else audio.pause();
  }

  return (
    <div className="guide-audio">
      <div className="cluster">
        <button className="btn small" type="button" onClick={toggle}>Play / pause</button>
        <label className="check-line">
          <input type="checkbox" checked={loop} onChange={(event) => setLoop(event.target.checked)} />
          Loop
        </label>
        <span className="faint">{label}</span>
      </div>
      {error && <p className="notice">{error}</p>}
      {src && <audio ref={audioRef} src={src} loop={loop} controls preload="metadata" />}
    </div>
  );
}
